const NubeSubirArchivo = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 41 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 29.9836C37.909 29.7263 41 26.4741 41 22.5C41 19.3309 39.0345 16.6209 36.256 15.5226C36.7311 14.6196 37 13.5912 37 12.5C37 8.91015 34.0899 6 30.5 6C29.0482 6 27.7076 6.47594 26.6257 7.28031C25.4411 3.07915 21.5801 0 17 0C11.4772 0 7 4.47715 7 10C7 10.1524 7.00341 10.3039 7.01015 10.4546C2.9478 11.7257 0 15.5186 0 20C0 25.1853 3.94668 29.4489 9 29.9506V30H10H33.5H34V29.9836Z"
        fill="#006299"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1369 10.1332C20.06 10.0611 19.9403 10.0611 19.8634 10.1332L13.3693 16.2192C13.237 16.3431 13.3247 16.5651 13.5061 16.5651H16.8012C16.9116 16.5651 17.0012 16.6546 17.0012 16.7651V24.7995C17.0012 24.9099 17.0907 24.9995 17.2012 24.9995H22.8012C22.9116 24.9995 23.0012 24.9099 23.0012 24.7995V16.7651C23.0012 16.6546 23.0907 16.5651 23.2012 16.5651H26.4943C26.6756 16.5651 26.7634 16.3431 26.631 16.2192L20.1369 10.1332Z"
        fill="white"
      />
    </svg>
  );
};

export default NubeSubirArchivo;
